import type { FC, SVGProps } from "react"

const FooterTikTok: FC<SVGProps<SVGSVGElement>> = props => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.43752 0.0166667C10.5292 0 11.6125 0.00833333 12.6959 0C12.7625 1.275 13.2209 2.575 14.1542 3.475C15.0875 4.4 16.4042 4.825 17.6875 4.96667V8.325C16.4875 8.28333 15.2792 8.03333 14.1875 7.51667C13.7125 7.3 13.2709 7.025 12.8375 6.74167C12.8292 9.175 12.8459 11.6083 12.8209 14.0333C12.7542 15.2 12.3709 16.3583 11.6959 17.3167C10.6042 18.9167 8.71252 19.9583 6.77085 19.9917C5.57919 20.0583 4.38752 19.7333 3.37085 19.1333C1.68752 18.1417 0.504186 16.325 0.329186 14.375C0.312519 13.9583 0.304186 13.5417 0.320852 13.1333C0.470852 11.55 1.25419 10.0333 2.47085 9C3.85419 7.8 5.78752 7.225 7.59585 7.56667C7.61252 8.8 7.56252 10.0333 7.56252 11.2667C6.73752 11 5.77085 11.075 5.04585 11.575C4.52085 11.9167 4.12085 12.4417 3.91252 13.0333C3.73752 13.4583 3.78752 13.925 3.79585 14.375C3.99585 15.7417 5.31252 16.8917 6.71252 16.7667C7.64585 16.7583 8.53752 16.2167 9.02085 15.425C9.17918 15.15 9.35419 14.8667 9.36252 14.5417C9.44585 13.05 9.41252 11.5667 9.42085 10.075C9.42919 6.71667 9.41252 3.36667 9.43752 0.0166667V0.0166667Z"
      fill="#8B8987"
    />
  </svg>
)

export default FooterTikTok
